/**
 * @generated SignedSource<<348e9d716a204f94baaea7663bfad8a3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type InviteUsersInput = {
  emails: ReadonlyArray<string>;
};
export type UserInvite_inviteUsers_Mutation$variables = {
  input: InviteUsersInput;
};
export type UserInvite_inviteUsers_Mutation$data = {
  readonly inviteUsers: {
    readonly emails: ReadonlyArray<string>;
  } | null;
};
export type UserInvite_inviteUsers_Mutation = {
  response: UserInvite_inviteUsers_Mutation$data;
  variables: UserInvite_inviteUsers_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "InviteUsersPayload",
    "kind": "LinkedField",
    "name": "inviteUsers",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "emails",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserInvite_inviteUsers_Mutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserInvite_inviteUsers_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d12c6ac159991c65ed2a9fc6294019f5",
    "id": null,
    "metadata": {},
    "name": "UserInvite_inviteUsers_Mutation",
    "operationKind": "mutation",
    "text": "mutation UserInvite_inviteUsers_Mutation(\n  $input: InviteUsersInput!\n) {\n  inviteUsers(input: $input) {\n    emails\n  }\n}\n"
  }
};
})();

(node as any).hash = "2f14b212843da166ceace71578e5538b";

export default node;
